/**
 * Types POD (S5.6) — alias FE typés sur le codegen OpenAPI.
 *
 * Source de vérité : `backend/app/schemas/pod.py`. Pas de mapper BE↔FE —
 * les rows sont consommées telles quelles côté hooks/composants.
 */

import type { components } from './api-generated'

// Schémas exposés par les routes /api/pod/* (S5.6 PR-C — voie UI portail
// démantelée, `PodProviderResponse`/`PodConnectRequest`/`PodConnectionResponse`
// supprimés côté BE et FE).
export type PodProvider = components['schemas']['PodProvider']
export type PodProductStatus = components['schemas']['PodProductStatus']

export type PodPreparePayload = components['schemas']['PodPreparePayload']
export type PodProductResponse = components['schemas']['PodProductResponse']

// Helpers d'affichage UI — labels FR pour `<PodStatusBadge>` et autre.

export const POD_PRODUCT_STATUS_FR: Record<PodProductStatus, string> = {
  draft: 'Brouillon',
  uploading: 'Préparation…',
  ready: 'Prêt',
  failed: 'Échec',
  archived: 'Archivé',
}

export const POD_PROVIDER_LABEL_FR: Record<PodProvider, string> = {
  gelato: 'Gelato',
  mock: 'Mock POD',
}
